import { useTranslation } from "react-i18next";
import { useLocation } from "wouter";
import { PageStub } from "../components/ui/PageStub";

export function SignUp() {
  const { t } = useTranslation();
  const [, navigate] = useLocation();
  return (
    <PageStub title={t("auth.signUp")} back="/">
      <div className="flex flex-col gap-3 w-full max-w-xs">
        {(["google", "apple", "email"] as const).map((p) => (
          <button
            key={p}
            onClick={() => navigate("/profile")}
            className="px-6 py-3 rounded-2xl border border-[var(--color-gold)]/40 bg-[var(--color-night-deep)] text-[var(--color-washi)] hover:border-[var(--color-gold)] transition"
          >
            {t(`auth.${p}`)}
          </button>
        ))}
      </div>
    </PageStub>
  );
}
